import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { filterObj } from '@/utils/util';
import { getAction } from '@/api/manage';
export default {
  name: 'JSelectMultiUserModal',
  data: function data() {
    return {
      title: "用户列表",
      names: [],
      visible: false,
      placement: 'right',
      description: '人员管理页面',
      // 查询条件
      queryParam: {},
      // 表头
      columns1: [{
        title: '#',
        dataIndex: '',
        key: 'rowIndex',
        width: 50,
        align: "center",
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        title: '姓名',
        align: "center",
        width: 113,
        dataIndex: 'name'
      }, {
        title: '年龄',
        align: "center",
        width: 100,
        dataIndex: 'age'
      }, {
        title: '出生日期',
        align: "center",
        width: 100,
        dataIndex: 'birthday'
      }],
      columns2: [{
        title: '用户账号',
        align: "center",
        width: 100,
        dataIndex: 'name'
      }, {
        title: '操作',
        dataIndex: 'action',
        align: "center",
        width: 100,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      //数据集
      dataSource1: [],
      dataSource2: [],
      // 分页参数
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: function showTotal(total, range) {
          return range[0] + "-" + range[1] + " 共" + total + "条";
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      loading: false,
      selectedRowKeys: [],
      selectedRows: [],
      url: {
        list: "/test/jeecgDemo/list"
      }
    };
  },
  created: function created() {
    this.loadData();
  },
  methods: {
    searchQuery: function searchQuery() {
      this.loadData(1);
    },
    searchReset: function searchReset() {
      this.queryParam = {};
      this.loadData(1);
    },
    handleCancel: function handleCancel() {
      this.visible = false;
    },
    handleOk: function handleOk() {
      this.$emit("selectFinished", this.dataSource2);
      this.visible = false;
    },
    add: function add() {
      this.visible = true;
    },
    loadData: function loadData(arg) {
      var _this = this;

      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }

      var params = this.getQueryParams(); //查询条件

      getAction(this.url.list, params).then(function (res) {
        if (res.success) {
          _this.dataSource1 = res.result.records;
          _this.ipagination.total = res.result.total;
        }
      });
    },
    getQueryParams: function getQueryParams() {
      var param = Object.assign({}, this.queryParam, this.isorter);
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
    getQueryField: function getQueryField() {//TODO 字段权限控制
    },
    onSelectAll: function onSelectAll(selected, selectedRows, changeRows) {
      if (selected === true) {
        for (var a = 0; a < changeRows.length; a++) {
          this.dataSource2.push(changeRows[a]);
        }
      } else {
        for (var b = 0; b < changeRows.length; b++) {
          this.dataSource2.splice(this.dataSource2.indexOf(changeRows[b]), 1);
        }
      } // console.log(selected, selectedRows, changeRows);

    },
    onSelect: function onSelect(record, selected) {
      if (selected === true) {
        this.dataSource2.push(record);
      } else {
        var index = this.dataSource2.indexOf(record); //console.log();

        if (index >= 0) {
          this.dataSource2.splice(this.dataSource2.indexOf(record), 1);
        }
      }
    },
    onSelectChange: function onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectedRows;
    },
    onClearSelected: function onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    handleDelete: function handleDelete(record) {
      this.dataSource2.splice(this.dataSource2.indexOf(record), 1);
    },
    handleTableChange: function handleTableChange(pagination, filters, sorter) {
      //分页、排序、筛选变化时触发
      console.log(sorter); //TODO 筛选

      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = "ascend" == sorter.order ? "asc" : "desc";
      }

      this.ipagination = pagination;
      this.loadData();
    }
  }
};